import TrainerBox from "./TrainerBox";

function Trainers() {
  return (
    <>
      <section id="team" className="trainers-section">
        <div className="container page-padding py-16 sm:py-24 md:py-28">
          {/* title div -- */}
          <div className="flex flex-col items-center text-center relative mb-12 sm:mb-16">
            <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
              <span>our trainer</span>
            </div>

            <h2 className="text-[26px] sm:text-[32px] md:text-[36px] font-bold mb-3 text-black">Expert Certified Coach</h2>
            <p className="text-[#646464] font-medium text-[14px] sm:text-[15px] max-w-lg leading-relaxed">
              Train under an internationally certified fitness expert. <br className="hidden sm:block" />
              Personalized guidance, motivation and real results!
            </p>
          </div>

          {/* trainers div -- */}
          <div className="flex justify-center w-full">
            <TrainerBox />
          </div>
        </div>
      </section>
    </>
  );
}

export default Trainers;
